import React, { useState, useMemo } from "react";
import useMethods from "use-methods";
import _ from "lodash";
import { Link } from "react-router-dom";
import { IconButton } from "@mui/material";
import { IoEye } from "react-icons/io5";

import AdminLayout from "../../template/admin.layout";
import TableListTemplate, {
  getTableListMethods,
} from "../../components/table-list-page.template";
import { useTableListPage } from "../../../../../hooks/useTableListPage";
import Datatable from "../../components/datatable/datatable";
import { useGetAgentsList } from "../../../../../services/microservice/admin/agents/use-agents-admin";
import { IUser } from "../../../../../services/microservice/admin/types/admin.types";
import Chip from "../../../../../components/chip/chip";
import { useAgentsAdminContext } from "../../providers/agents-admin.provider";

const initialState: any = {
  filters: {},
  count: 0,
  currentPage: 0,
  perPage: 10,
  perPageOptions: [10, 20, 30],
};

const methods = (state: any) => ({
  ...getTableListMethods(state),
});

const AgentsListAdminPage = () => {
  const [state, stateMethods] = useMethods(methods, initialState);
  const { sponsor } = useAgentsAdminContext();
  const { data, isLoading } = useGetAgentsList();

  const { updateCount } = stateMethods;

  const headCells = useMemo(
    () => [
      {
        id: "name",
        numeric: false,
        disablePadding: true,
        Header: "Nombre",
        accessor: (d: IUser) => `${d.name}`,
      },
      {
        id: "email",
        numeric: true,
        disablePadding: false,
        Header: "Correo electrónico",
        accessor: (d: IUser) => `${d.email}`,
      },
      {
        id: "phone_number",
        numeric: true,
        disablePadding: false,
        Header: "Número de contacto",
        accessor: (d: IUser) => `${d.phone_number}`,
      },
      {
        id: "sponsor",
        numeric: false,
        disablePadding: false,
        Header: "Sponsor",
        accessor: (d: IUser) =>
          d.sponsor ? `${d.sponsor.name}` : "No asignado",
      },
      {
        id: "isActive",
        numeric: false,
        disablePadding: false,
        Header: "Activo",
        accessor: (d: IUser) => <Chip isActive={d.isActive} />,
      },
      {
        id: "acciones",
        Header: "Acciones",
        accessor: (d: IUser) => (
          <div className="flex flex-row items-center justify-center gap-2">
            <Link to={`/${sponsor}/admin/agents/${d._id}`}>
              <IconButton size="small">
                <IoEye />
              </IconButton>
            </Link>
          </div>
        ),
      },
    ],
    [sponsor],
  );

  const rowsData = useMemo(() => {
    if (!data?.data.users) return [];
    return data.data.users.slice(
      state.currentPage * state.perPage,
      state.currentPage * state.perPage + state.perPage,
    );
  }, [data?.data.users, state.currentPage, state.perPage]);

  useTableListPage({
    state,
    count: data?.data?.users.length,
    updateCount,
    refetch: () => {},
  });

  return (
    <AdminLayout>
      <div className="mt-28 w-full">
        <TableListTemplate
          isLoading={isLoading}
          isEmpty={_.isEmpty(data?.data)}
          title={
            <div className="flew-row flex h-full w-full items-center justify-between">
              <div>Agentes</div>
            </div>
          }
          table={<Datatable data={rowsData} columns={headCells} stickyHeader />}
          tableListMethods={stateMethods}
          tableListState={state}
        />
      </div>
    </AdminLayout>
  );
};

export default AgentsListAdminPage;
